<template>
    <!--新增对话框-->
    <el-dialog title="编辑常量数据配置" :visible.sync="dialogVisible" width="800px" append-to-body :close-on-click-modal="false"
        :before-close="handleClose">

        <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">
            <el-form-item label="优惠金额" prop="money" label-width="100px">
                <el-input v-model="editForm.money" autocomplete="off" type="number"></el-input>
            </el-form-item>
            <el-form-item label="发放数量" prop="number" label-width="100px">
                <el-input v-model="editForm.number" autocomplete="off" type="number"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('editForm')">立即创建</el-button>
                <el-button @click="resetForm('editForm')">重置</el-button>
            </el-form-item>
        </el-form>

    </el-dialog>
</template>

<script>
export default {
    name: "UpdateSysMemberCoupon",
    data() {
        return {
            editForm: {},
            editFormRules: {
                money: [
                    { required: true, message: '请输入优惠金额', trigger: 'blur' }
                ],
                number: [
                    { required: true, message: '请输入发放数量', trigger: 'blur' }
                ]
            },
            dialogVisible: false,
        }
    },
    methods: {
        change(val) {
            this.editForm.describe = val;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.dialogVisible = false
            this.editForm = {}
        },
        handleClose() {
            this.resetForm('editForm')
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                console.log("valid", valid)
                if (valid) {
                    this.$axios.post('/admin/sysMemberCoupon/updSysMemberCoupon', this.editForm)
                        .then(res => {
                            this.$message({
                                showClose: true,
                                message: '恭喜你，操作成功',
                                type: 'success',
                                onClose: () => {
                                    this.$emit('refreshDataList')
                                }
                            });
                            this.dialogVisible = false
                            this.resetForm(formName)
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        init(id) {
            this.dialogVisible = true;
            if (id != null && id != '') {
                this.$axios.post('/admin/sysMemberCoupon/getSysMemberCouponInfo', { id: id }).then(res => {
                    this.editForm = res.data
                })
            }
        },
    }
}
</script>

<style scoped></style>
